import React, { FC, Fragment, useEffect, useRef, useState } from 'react';
import { CONSTANTS } from 'config/constants';
import { Box, LinearProgress } from '@mui/material';
import Cookies from 'js-cookie';

const { ELASTIC_PROXY_HOST, TOKEN_KEY } = CONSTANTS;

type LabElasticDashboardProps = {
    dashboardFramePath: string;
};
const LabElasticDashboard: FC<LabElasticDashboardProps> = ({ dashboardFramePath }: LabElasticDashboardProps) => {
    const token = Cookies.get(TOKEN_KEY);
    const iframeUrl = `${ELASTIC_PROXY_HOST}/s/standard-lab/app/dashboards?denthubtoken=${token}#${dashboardFramePath}`;
    const iFrameRef = useRef<HTMLIFrameElement>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        iFrameRef.current?.addEventListener('load', () => {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        });
        return () => {
            iFrameRef.current?.removeEventListener('load', () => setLoading(true));
        };
    }, [iFrameRef.current]);

    return (
        <Fragment>
            {loading ? <LinearProgress color="secondary" /> : undefined}
            <Box sx={{ height: '81vh', position: 'relative', overflow: 'hidden', width: '100%' }}>
                <iframe
                    ref={iFrameRef}
                    src={iframeUrl}
                    style={{
                        position: 'absolute',
                        border: 0,
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        width: '100%',
                        height: '100%',
                    }}
                ></iframe>
            </Box>
        </Fragment>
    );
};

export default LabElasticDashboard;
